





























































import { Vue, Component } from 'vue-property-decorator';
import L from 'leaflet';
import {
  LMap, LTileLayer, LMarker, LControl, LPopup,
} from 'vue2-leaflet';
import DialogForm from '@/components/map/DialogFormButton.vue';
import ProposalCard from '@/components/ProposalCard.vue';
import { Proposal } from '../interfaces/Proposal';

interface MapElement {
  mapObject: L.Map;
}

@Component({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    DialogForm,
    ProposalCard,
  },
})
export default class Map extends Vue {
  $refs!: {
    map: MapElement & HTMLElement,
  };

  protected url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';

  protected attribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';

  protected startCoordinates = [47.4254995925386, 9.377487163874322];

  protected zoom = 15;

  protected mapObject!: L.Map;

  protected wasUserLocationFound = false;

  protected userLocation: number[] = [];

  protected selectedMarker: number[] = [];

  protected snackbarOpen = false;

  getMarkerIcon = (color: string): L.Icon => new L.Icon({
    iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  addMarker(e: L.LocationEvent): void {
    if (e.latlng) {
      this.selectedMarker = [e.latlng.lat, e.latlng.lng];
      this.snackbarOpen = true;
    }
  }

  mapReady(): void {
    this.mapObject = this.$refs.map.mapObject;
    this.mapObject.on('locationfound', (e: L.LocationEvent) => {
      if (!this.wasUserLocationFound) {
        this.wasUserLocationFound = true;
        this.mapObject.flyTo(e.latlng);
      }

      this.userLocation = [e.latlng.lat, e.latlng.lng];
    });

    this.mapObject.locate({ watch: true });

    this.currentProposals.forEach((proposal: Proposal) => {
      if (proposal.selected) {
        this.mapObject.panTo({ lat: proposal.location[0], lng: proposal.location[1] });
      }
    });
  }

  get currentProposals(): Proposal[] {
    return this.$store.state.proposals;
  }

  createNewProposal(proposal: Proposal): void {
    const newProposal: Proposal = {
      ...proposal,
      location: this.selectedMarker,
      status: 'created',
      /* eslint-disable-next-line */
      votes: 0,
      type: 'Test',
    };

    this.$store.commit('addNewProposal', newProposal);
  }

  goToCurrentLocation(): void {
    this.mapObject.panTo({ lat: this.currentUserLocation[0], lng: this.currentUserLocation[1] });
  }

  get currentUserLocation(): number[] {
    return this.userLocation.length === 2 ? this.userLocation : this.startCoordinates;
  }

  goToProposals(): void {
    this.$router.push('/vote');
  }

  selectProposal = (proposal: Proposal): void => {
    this.$store.commit('setSelectedProposal', { proposal, selected: !proposal.selected });
  }
}
